import ItemSkuBookmarkIndexPage from '../../../components/pages/mypages/item_sku_bookmarks/ItemSkuBookmarkIndexPage.vue'

export default {
  components: {
    ItemSkuBookmarkIndexPage
  }
}
